import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import {
  Accordion,
  AccordionDetails,
  Box,
  Grid,
  CircularProgress,
  Backdrop,
  Typography,
  Divider,
  Paper,
} from "@mui/material";
import moment from "moment";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import { moneyformatter } from "src/common/utils/helpers";
import CommonButtonDefault from "src/components/CommonButton/CommonButtonDefault";
import Heading from "./Heading";
import { useStyles } from "./styles";

type Props = {
  expand: boolean;
  updateExpandStatus: (type: number) => void;
};

export function Crew({ expand, updateExpandStatus }: Props): React.ReactElement {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loader, setLoader] = useState(false);
  const [crewDetails, setCrewDetails] = useState<any[]>([]);
  const [crewHeader, setCrewHeader] = useState<{ nte?: number; deductions?: number; total?: number } | null>(null);
  const { crewId } = useParams<{ crewId: any }>();

  const loadCrewData = async () => {
    if (!crewId) return;
    try {
      setLoader(true);
      const [crewHeaderRes, crewDetailsRes] = await Promise.all([
        fetchWrapper.get(`get-order-crew-by-crew-id/${crewId}`),
        fetchWrapper.get(`get-order-crew-detail-by-crew-id/${crewId}`),
      ]);
      setCrewHeader({
        nte: crewHeaderRes?.nte,
        deductions: crewHeaderRes?.deductions,
        total: crewHeaderRes?.total,
      });
      setCrewDetails(crewDetailsRes?.crewDetails ?? []);
    } catch (error: any) {
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    } finally {
      setLoader(false);
    }
  };

  React.useEffect(() => {
    if (expand) {
      loadCrewData();
    }
  }, [expand]);
  return (
    <>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box border={1} mb={2} borderColor="grey.200">
        <Accordion square elevation={0} expanded={expand} onChange={() => updateExpandStatus(3)}>
          <Heading heading="Crew" />
          <Box borderTop={1} mb={1} borderColor="grey.200"></Box>
          <AccordionDetails>
            <Paper elevation={0} square className={classes.root}>
              <Box p={1}>
                {crewHeader != null && (
                  <Box mb={2} pl={1} pr={1} py={1} width="100%">
                    <Box display="flex" flexDirection="row" alignItems="baseline" width="100%">
                      <Box className={classes.crewLabelCol}>
                        <Typography variant="body1" color="text.secondary">Original NTE:</Typography>
                      </Box>
                      <Box className={classes.crewValueCol}>
                        <Typography variant="body1">{moneyformatter(crewHeader.nte)}</Typography>
                      </Box>
                    </Box>
                    <Box display="flex" flexDirection="row" alignItems="baseline" width="100%" mt={0.5}>
                      <Box className={classes.crewLabelCol}>
                        <Typography variant="body1" color="text.secondary">Deductions:</Typography>
                      </Box>
                      <Box className={classes.crewValueCol}>
                        <Typography variant="body1">{moneyformatter(crewHeader.deductions)}</Typography>
                      </Box>
                    </Box>
                    <Box display="flex" flexDirection="row" alignItems="baseline" width="100%" mt={0.5}>
                      <Box className={classes.crewLabelCol}>
                        <Typography variant="body1" color="text.secondary">Total NTE:</Typography>
                      </Box>
                      <Box className={classes.crewValueCol}>
                        <Typography variant="body1">{moneyformatter(crewHeader.total)}</Typography>
                      </Box>
                    </Box>
                  </Box>
                )}
                {crewDetails.map((crewDetail: any, index: number) => (
                  <Box mt={2} key={index}>
                    <Grid item xs={12} md={12}>
                      <Grid container direction="row">
                        <Grid item xs={12} md={12} className={classes.oddRow}>
                          <Box pl={1} pr={1} my={1}>
                            <Grid container direction="row">
                              <Grid item xs={12} md={12}>
                                <Grid container direction="row" wrap="nowrap">
                                  <Grid item xs={12} md={5} className={classes.crewColVisitDate}>
                                    <Box display="flex" flexDirection="row" flexWrap="nowrap" justifyContent="flex-start">
                                      <Box color="text.secondary" mr={1}>
                                        <Typography>Visit Date:</Typography>
                                      </Box>
                                      <Box color="text.primary" ml={0.5}>
                                        <Typography>
                                          {moment(crewDetail.visitDate).format(
                                            "dddd, MM/DD/YYYY hh:mm A"
                                          )}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} md={4} className={classes.crewColStatus}>
                                    <Box display="flex" flexDirection="row" flexWrap="nowrap" justifyContent="flex-start">
                                      <Box color="text.secondary" mr={1}>
                                        <Typography>Status:</Typography>
                                      </Box>
                                      <Box color="text.primary" ml={0.5}>
                                        <Typography>{crewDetail.status}</Typography>
                                      </Box>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} md={3} className={classes.crewColDeductions}>
                                    <Box display="flex" flexDirection="row" flexWrap="nowrap" justifyContent="flex-start">
                                      <Box color="text.secondary" mr={1}>
                                        <Typography>Deductions:</Typography>
                                      </Box>
                                      <Box color="text.primary" ml={0.5}>
                                        <Typography>
                                          {moneyformatter(crewDetail.deductions)}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  </Grid>
                                </Grid>
                              </Grid>
                              {/* <Grid item xs={12} md={3}>
                      <Box textAlign="right">
                        <Box component="span" mr={1}>
                          <CommonButtonDefault
                            onClick={() => {
                              // printWO(crewDetail.orderCrewDetailId);
                              console.log("");
                            }}
                          >
                            Print WO
                          </CommonButtonDefault>
                        </Box>
                        <Box component="span" mr={1}>
                          <CommonButtonDefault
                            onClick={() => {
                              // auditCrewDispatch(crewDetail.orderCrewDetailId);
                              console.log("");
                            }}
                          >
                            Audit
                          </CommonButtonDefault>
                        </Box>
                        <Box component="span" mr={1}>
                          <CommonButtonDefault
                            onClick={() => {
                              // editCrewDispatch(item, crewDetail);
                              console.log("");
                            }}
                          >
                            Edit
                          </CommonButtonDefault>
                        </Box>
                      </Box>
                    </Grid> */}
                            </Grid>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Divider />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                ))}
              </Box>
            </Paper>
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  );
}
